<template>
  <div>
    <v-layout wrap justify-center mt-12>
      <v-flex xs12 sm9 v-if="isUpdatingSubscription">
        <v-progress-linear indeterminate />
      </v-flex>
      <v-flex xs12 sm9 v-else-if="isUpdateSubscriptionSuccess" text-center>
        <div class="mt-12">
          <img :src="images.success" height="300px">
        </div>
        <h3 class="secondary--text mt-12"><v-icon class="secondary--text mr-1">mdi-check</v-icon>{{ $t('a') }}</h3>
        <v-btn to="/dossiers/create" class="mt-6 outlinedButtonWhiteBackground" outlined>
          <v-icon small class="mr-2">mdi-plus</v-icon>
          {{ $t('b') }}
        </v-btn>
      </v-flex>
      <v-flex xs12 sm9 v-else-if="!currentSubscription || !currentPlan">
        <v-progress-linear indeterminate/>
      </v-flex>
      <v-flex xs12 sm9 v-else-if="currentSubscription && !['active', 'trialing'].includes(currentSubscription.status)">
        <v-layout wrap>
          <v-flex xs12 mt-12>
            <h1 >{{ $t('disabled1') }}</h1>
            <v-progress-linear v-if="isInitStripeBasicCustomerPortalSessionPending" indeterminate/>
            <div class="mb-3">
              <small>{{ $t('disabled2') }}</small>
            </div>
            <v-btn v-if="stripeBasicCustomerPortalUrl" class="secondary" :href="stripeBasicCustomerPortalUrl" target="_blank">
              {{ $t('disabled3') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm9 v-else-if="currentSubscription && ['active', 'trialing'].includes(currentSubscription.status)">
        <v-layout wrap justify-center>
          <v-flex xs12>
            <h2>{{ $t('e') }}</h2>
            <v-layout wrap>
              <v-flex xs8>
                <b>{{ currentPlan.numberOfDossiersPerMonth }} {{ $t('f') }}</b>
                <small>
                  <div v-if="currentPlan.isYearly">
                    {{ $t('g') }} {{ currentPlan.amount }}€, {{ $t('h') }} {{ currentPeriodEnd.getDate() }}/{{ currentPeriodEnd.getMonth() + 1 }}.
                  </div>
                  <div v-else>
                    {{ $t('i') }} {{ currentPlan.amount }}€, {{ $t('j') }} {{ currentMonthlyPeriodEnd.getDate() }} {{ $t('k') }}
                  </div>
                  <div v-if="currentSubscription.cancel_at_period_end">
                    <div>{{ $t('l') }} {{ currentPeriodEnd.toLocaleDateString() }}</div>
                    <div class="mt-3">
                      <v-progress-linear v-if="isInitStripeDowngradeCustomerPortalSessionPending" indeterminate/>
                      <v-btn v-if="stripeDowngradeCustomerPortalUrl" small outlined :href="stripeDowngradeCustomerPortalUrl" target="_blank">{{ $t('m') }}</v-btn>
                    </div>
                  </div>
                </small>
              </v-flex>
              <v-flex xs4 text-end>
                <div v-if="!(currentSubscription && currentSubscription.cancel_at_period_end)">
                  <div v-if="isInitStripeDowngradeCustomerPortalSessionPending">
                    <v-progress-linear indeterminate/>
                  </div>
                  <div v-else-if="stripeDowngradeCustomerPortalUrl">
                    <small><a :href="stripeDowngradeCustomerPortalUrl" target="_blank">{{ $t('n') }}</a></small>
                  </div>
                </div>
              </v-flex>
            </v-layout>
            <v-layout wrap mt-12>
              <v-flex xs12>
                <h2>{{ $t('o') }}</h2>
              </v-flex>
              <v-flex xs12 v-if="!selectedPlan">
                <small>{{ $t('o2') }}</small>
              </v-flex>
              <v-flex xs12 mt-6>
                <pricing-selection
                  :initialIsYearly="currentPlan.isYearly"
                  :isYearlySwitchLocked="true"
                  :strictlyMinimumNumberOfDossiersPerMonth="currentPlan.numberOfDossiersPerMonth"
                  :isHidingYearlyDiscountText="true"
                  :parentCompany="parentCompany"
                  :loadedPlans="plans"
                  @onSelectedPlanChange="onSelectedPlanChange"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap v-if="selectedPlan" mt-12>
          <v-flex xs12 pl-8 v-if="companyOfSubscription.dossiersLeftNb > 0 && selectedPlan.numberOfDossiersPerMonth < 10000" mb-3>
            <small>
              <h3>{{ $t('p') }}</h3>
              <div>{{ $t('q') }} {{ companyOfSubscription.dossiersLeftNb }} {{ $t('r') }}</div>
              <div>{{ $t('s') }} {{ companyOfSubscription.dossiersLeftNb + selectedPlan.numberOfDossiersPerMonth }} {{ $t('t') }} {{ getNewPeriodEnd().toLocaleDateString() }}{{ $t('u') }} {{ selectedPlan.numberOfDossiersPerMonth }} {{ $t('v') }}</div>
            </small>
          </v-flex>
          <v-flex xs12 mt-6 mb-12 pb-12 v-if="selectedPlan">
            <v-card class="px-8 py-8">
              <v-layout wrap>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs9>
                      <h2>{{ $t('f1') }}</h2>
                    </v-flex>
                    <v-flex xs3 text-end>
                      <div v-if="isInitStripeBasicCustomerPortalSessionPending">
                        <v-progress-linear indeterminate/>
                      </div>
                      <div v-else-if="stripeBasicCustomerPortalUrl">
                        <small><a :href="stripeBasicCustomerPortalUrl" target="_blank" outlined>{{ $t('f2') }}</a></small>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap class="mt-2" style="font-size:0.9em;">
                    <v-flex xs12 v-if="selectedPlan.id === currentPlan.id">
                      {{ $t('f3') }}
                    </v-flex>
                    <v-flex xs12 v-else>
                      {{ $t('f4') }} {{ selectedPlan.numberOfDossiersPerMonth }} {{ $t('f5') }}
                      <div v-if="selectedPlan.isYearly">
                        <div v-if="yearlyDiscountForUnusedMonths && yearlyDiscountForUnusedMonths.unusedMonthesNb > 0">
                          <div class="mt-5 mb-6">
                            <div><b>{{ $t('f6') }}</b></div>
                            <div>{{ $t('f7') }} {{ yearlyDiscountForUnusedMonths.unusedMonthesNb }} {{ $t('f8') }} {{ currentPlan.amount }}€ {{ $t('f9') }}</div>
                            <div>{{ $t('f10') }} {{ yearlyDiscountForUnusedMonths.amountOffInEuros }}€ {{ $t('f11') }} {{ selectedPlan.amount }}€.</div>
                            <div>{{ $t('f12') }} <b>{{ selectedPlan.amount - yearlyDiscountForUnusedMonths.amountOffInEuros }}€</b> {{ $t('f13') }}</div>
                          </div>
                          <div v-if="companyOfSubscription.hasNoVAT">{{ $t('f14') }} {{ selectedPlan.amount - yearlyDiscountForUnusedMonths.amountOffInEuros }}€</div>
                          <div v-else>{{ $t('f15') }} {{ ((selectedPlan.amount - yearlyDiscountForUnusedMonths.amountOffInEuros) * 1.2).toFixed(2) }}€ ({{ selectedPlan.amount - yearlyDiscountForUnusedMonths.amountOffInEuros }}€ {{ $t('f16') }}).</div>
                          <div>{{ $t('f17') }} {{ selectedPlan.amount }}€ {{ $t('f18') }} {{ (new Date()).getDate() }}/{{ (new Date()).getMonth() + 1 }}.</div>
                        </div>
                        <div v-else>
                          <div>{{ $t('f19') }} {{ selectedPlan.amount }}€ {{ $t('f20') }} {{ (new Date()).getDate() }}/{{ (new Date()).getMonth() + 1 }}.</div>
                          <div v-if="companyOfSubscription.hasNoVAT">{{ $t('f21') }} <b>{{ selectedPlan.amount }}€</b></div>
                          <div v-else>{{ $t('f22') }} <b>{{ (selectedPlan.amount * 1.2).toFixed(2) }}€</b> ({{ selectedPlan.amount }}€ {{ $t('f23') }}).</div>
                        </div>
                      </div>
                      <div v-else>
                        <span v-if="companyOfSubscription.hasNoVAT">{{ $t('f24') }} <b>{{ selectedPlan.amount }}€</b></span>
                        <span v-else>{{ $t('f25') }} <b>{{ (selectedPlan.amount * 1.2).toFixed(2) }}€</b> ({{ selectedPlan.amount }}€ {{ $t('f26') }})</span>
                        <span>{{ $t('f27') }} {{ getNewPeriodEnd().getDate() }} {{ $t('f28') }}</span>
                      </div>
                      <v-layout wrap>
                        <v-flex xs12 text-center>
                          <v-btn class="mt-8 secondary" @click="upgradeSubscription">{{ $t('f29') }}</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import PricingSelection from '@/components/PricingSelection'
import { mapGetters } from "vuex";
import { getStripePlans } from '@/helpers/subscriptions.js';

export default {
  components: {
    PricingSelection
  },
  data: () => ({
    selectedPlan: null,
    stripeBasicCustomerPortalUrl: null,
    stripeDowngradeCustomerPortalUrl: null,
    stripeSubscribeCustomerPortalUrl: null,
    isUpdatingSubscription: false,
    isUpdateSubscriptionSuccess: false,
    isInitStripeBasicCustomerPortalSessionPending: false,
    isInitStripeDowngradeCustomerPortalSessionPending: false,
    currentSubscription: null,
    images: {
      success: require('@/assets/app/images/achievement_flatline.svg'),
    },
    parentCompany: null,
    plans: []
  }),
  async mounted() {
    this.plans = await getStripePlans(this.$db);

    if (this.user.company.parentCompanyId) {
      await this.fetchParentCompany()
    }
    this.initStripeBasicCustomerPortalSession()
    this.initStripeDowngradeCustomerPortalSession()
    await this.fetchCurrentSubscription()
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
    companyOfSubscription() {
      // Either user's company or its parentCompany
      if (this.user.company.parentCompanyId) {
        return this.parentCompany
      } else {
        return this.user.company
      }
    },
    currentPlan() {
      return this.getPlan(this.companyOfSubscription.pricingPlan)
    },
    currentMonthlyPeriodEnd() {
      return new Date(this.companyOfSubscription.currentMonthlyPeriodDates.endDate * 1000)
    },
    currentPeriodEnd() {
      return new Date(this.companyOfSubscription.currentPeriodDates.endDate * 1000)
    },
    yearlyDiscountForUnusedMonths() {
      if (this.currentPlan.isYearly) {
        const current_period_start = this.companyOfSubscription.currentPeriodDates.startDate
        const current_period_end = this.companyOfSubscription.currentPeriodDates.endDate
        let usedMonthesNb = Math.ceil(12 * (Date.now()/1000 - current_period_start) / (current_period_end - current_period_start))
        const unusedMonthesNb = 12 - usedMonthesNb
        const amountOffInEuros = Math.round(unusedMonthesNb * this.currentPlan.amount / 12)
        return {
          amountOffInEuros,
          unusedMonthesNb
        }
      } else {
        return null
      }
    }
  },
  methods: {
    onSelectedPlanChange(selectedPlan) {
      this.selectedPlan = selectedPlan
    },
    getPlan(planId) {
      if (!this.plans) return null;
      const allPlans = this.plans.monthlyPlans.concat(this.plans.yearlyPlans).concat(this.plans.hiddenMonthlyPlans).concat(this.plans.hiddenYearlyPlans)
      return allPlans.find(plan => plan.id === planId)
    },
    async initStripeBasicCustomerPortalSession() {
      this.isInitStripeBasicCustomerPortalSessionPending = true
      const stripeSessionReponse = await this.$functions.httpsCallable('createStripeCustomerPortalSession')({
        mode: 'basic',
        returnUrl: window.location.origin + '/account'
      })
      this.stripeBasicCustomerPortalUrl = stripeSessionReponse.data.url
      this.isInitStripeBasicCustomerPortalSessionPending = false
    },
    async initStripeDowngradeCustomerPortalSession() {
      this.isInitStripeDowngradeCustomerPortalSessionPending = true
      const stripeSessionReponse = await this.$functions.httpsCallable('createStripeCustomerPortalSession')({
        mode: 'downgrade',
        returnUrl: window.location.origin + '/account'
      })
      this.stripeDowngradeCustomerPortalUrl = stripeSessionReponse.data.url
      this.isInitStripeDowngradeCustomerPortalSessionPending = false
    },
    getNewPeriodEnd() {
      const nowDate = new Date()
      return new Date(nowDate.setMonth(nowDate.getMonth() + 1))
    },
    async upgradeSubscription() {
      this.isUpdatingSubscription = true
      await this.$functions.httpsCallable('upgradeSubscription')({ newPlanId: this.selectedPlan.id })
      this.isUpdateSubscriptionSuccess = true
      this.isUpdatingSubscription = false
    },
    async fetchCurrentSubscription() {
      this.currentSubscription = (await this.$functions.httpsCallable('getCurrentSubscription')()).data.subscription
    },
    async fetchParentCompany() {
      this.parentCompany = (await this.$functions.httpsCallable('getParentCompany')()).data.parentCompany
    },
  }

  
}
</script>



<i18n>
{
  "fr": {
    "a": "Votre abonnement a été mis à jour avec succès.",
    "b": "Créer un nouveau dossier",
    "disabled1": "Abonnement désactivé",
    "disabled2": "Le paiement de votre dernière facture n'a pas été réalisé.",
    "disabled3": "Gérer les paiements",
    "e": "Votre abonnement actuel",
    "f": "dossiers / mois",
    "g": "Facturation annuelle de",
    "h": "renouvelée tous les ans le",
    "i": "Facturation mensuelle de",
    "j": "renouvelée tous les",
    "k": "du mois.",
    "l": "Votre abonnement se terminera le",
    "m": "Prolonger votre abonnement",
    "n": "Réduire ou annuler votre abonnement",
    "o": "Prendre un abonnement supérieur",
    "o2": "Contactez-nous à martin@esnwebservices.com",
    "p": "Vos dossiers restants sont conservés",
    "q": "Il vous reste",
    "r": "dossiers non consommés de votre mois actuel. Ils seront ajoutés à votre nouveau solde.",
    "s": "Vous aurez donc",
    "t": "dossiers à consommer avant le",
    "u": ", puis",
    "v": "dossiers consommables chaque mois.",
    "f1": "Facturation",
    "f2": "Changer le mode de paiement",
    "f3": "Pas de changement d'abonnement.",
    "f4": "Vous passerez dès maintenant à l'abonnement à",
    "f5": "dossiers/mois.",
    "f6": "Remise",
    "f7": "Il vous restait",
    "f8": "mois inutilisés sur votre abonnement actuel à",
    "f9": "par an.",
    "f10": "Ceci vous fait une remise de",
    "f11": "sur les",
    "f12": "Montant après remise :",
    "f13": "HT",
    "f14": "Vous allez donc être facturé maintenant de",
    "f15": "Vous allez être facturé maintenant de",
    "f16": "+ 20% de TVA",
    "f17": "Puis de",
    "f18": "HT les années suivantes chaque",
    "f19": "Montant à régler :",
    "f20": "HT, renouvelé chaque année le",
    "f21": "Vous allez être facturé maintenant de",
    "f22": "Vous allez être facturé maintenant de",
    "f23": "+ 20% de TVA",
    "f24": "Vous allez être facturé maintenant de",
    "f25": "Vous allez être facturé maintenant de",
    "f26": "+ 20% de TVA",
    "f27": ", renouvelé chaque",
    "f28": "du mois.",
    "f29": "Mettre à jour l'abonnement et payer"
  },
  "en": {
    "a": "Your subscription has successfully been updated.",
    "b": "Transform a new CV",
    "disabled1": "Subscription disabled",
    "disabled2": "The last payment has not been made.",
    "disabled3": "Manage payments",
    "e": "Your current subscription",
    "f": "CVs / month",
    "g": "Yearly billing of",
    "h": "renewed each year on the",
    "i": "Monthly billing of",
    "j": "renew each month of the",
    "k": "of each month.",
    "l": "Your subscription will end up on the",
    "m": "Renew you subscription",
    "n": "Downgrade or cancel your subscription",
    "o": "Upgrade your subscription",
    "o2": "Contact us at martin@esnwebservices.com",
    "p": "You keep your unused credits",
    "q": "You have",
    "r": "unused CV credits for your current month. You will still be able to use them after upgrading.",
    "s": "You will thus have",
    "t": "CVs to transform before the",
    "u": ", then",
    "v": "transformable CVs each months.",
    "f1": "Billing",
    "f2": "Change payment method",
    "f3": "No change in subscription",
    "f4": "You will now upgrade to the ",
    "f5": "CVs/month subscription.",
    "f6": "Discount",
    "f7": "You still have",
    "f8": "unused months in your subscription at",
    "f9": "per year.",
    "f10": "This creates a discount of",
    "f11": "on the",
    "f12": "To pay, after discount:",
    "f13": "(excluding VAT).",
    "f14": "You will thus now be billed of",
    "f15": "You will now be billed of",
    "f16": "+ 20% VAT",
    "f17": "Then of",
    "f18": "(excluding VAT) on the following years on each",
    "f19": "To pay:",
    "f20": "(excluding VAT), renewed each year on the",
    "f21": "You will now be billed of",
    "f22": "You will now be billed of",
    "f23": "+ 20% VAT",
    "f24": "You will now be billed of",
    "f25": "You will now be billed of",
    "f26": "+ 20% VAT",
    "f27": ", renewed on the",
    "f28": "of each month.",
    "f29": "Upgrade subscription and pay"
  }
}
</i18n>